<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    export default {
        Steps: defineAsyncComponent(() => import(/* webpackChunkName: "ui-steps" */'@/components/UI/Steps/Steps.vue')),
        StepsItem: defineAsyncComponent(() => import(/* webpackChunkName: "ui-steps" */'@/components/UI/Steps/Item.vue')),
    }
</script>